import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import dayjs from "dayjs";


// Função para gerar o Excel
export const generateMonitoramentoExcel = async (selectedData) => {


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Participantes");

    // Ajuste de altura das linhas


    // Adiciona a imagem entre as colunas A e B (linhas 1 e 2)





    // Adiciona o título principal na linha 3 (mesclado de A até E)
    worksheet.mergeCells("A1:E1");
    const headerTitleCell = worksheet.getCell("A1");
    headerTitleCell.value = "Lista de participantes";
    headerTitleCell.alignment = { horizontal: "center", vertical: "middle" };
    headerTitleCell.font = { bold: true, size: 12 };

    // Adiciona os cabeçalhos da tabela na linha 4
    const headers = ["Nome", "WHATSAPP", "Grupo participante", "Segue no Instagram?", "Data"];
    worksheet.addRow(headers);
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, size: 11 };
    headerRow.alignment = { horizontal: "center", vertical: "middle" };

    // Adiciona os dados da tabela na linha 5
    selectedData.forEach(function (item) {
        worksheet.addRow([
            item.nome,
            item.numero_wpp,
            item.grupo,
            item.status == 1 ? "Sim" : "Não",
            `${dayjs(item.created_at).format("DD/MM/YYYY")}`, // Formata as datas


        ]);
    });

    // Ajusta a largura das colunas
    worksheet.columns = [
        { key: "col1", width: 20 },
        { key: "col2", width: 25 },
        { key: "col3", width: 25 },
        { key: "col4", width: 20 },
        { key: "col5", width: 20 },
    ];

    // Salva o arquivo
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "participantes.xlsx");
};
